// Macedonian translations
export const mk: Record<string, string> = {
  'menu.dashboard': 'Контролна табла',
  'menu.customers': 'Клиенти',
  'menu.products': 'Производи',
  'menu.users': 'Корисници',
  'menu.settings': 'Поставки',
  'menu.logout': 'Одјава',
  'dashboard.title': 'Контролна табла',
  'dashboard.newOrder': 'Нова нарачка',
  'order.title': 'Нова нарачка',
  'order.customer': 'Клиент',
  'order.products': 'Производи',
  'order.total': 'Вкупно',
  'users.title': 'Корисници',
  'users.name': 'Име',
  'users.email': 'Е-пошта',
  'common.yes': 'Да',
  'common.no': 'Не',
  'common.cancel': 'Откажи',
  'common.save': 'Зачувај',
  'common.search': 'Пребарај',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Најава',
  'login.welcome': 'Добредојдовте, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Е-пошта',
  'signup.phone': 'Телефон',
  'menu.reportsAndAccounting': 'Извештаи и сметководство',
  'menu.systemAndCommunication': 'Систем и комуникација',
};